import styled from 'styled-components';

export const Container = styled.section`
  margin-top: 16px;
  background: #fff;
  border: 1px solid ${(props) => props.theme.$gray300};
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);

  .btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;

    i {
      font-size: 16px;
    }
  }

  .btn-ia {
    color: #fff;
  }

  .btn-link {
    color: ${(props) => props.theme.$gray600};
    text-decoration: none;

    &:hover {
      color: ${(props) => props.theme.$gray900};
    }
  }

  .batch-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    padding: 14px 18px;
  }

  .batch-toggle {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 240px;
    border: 0;
    background: transparent;
    padding: 0;
    text-align: left;
  }

  .batch-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.theme.$bg_green};
    color: ${(props) => props.theme.$primary_green};
  }

  .batch-title-wrap {
    min-width: 0;
  }

  .batch-title {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 700;
    color: ${(props) => props.theme.$gray900};

    i {
      font-size: 20px;
      color: ${(props) => props.theme.$gray500};
      transition: transform 0.15s;

      &.open {
        transform: rotate(180deg);
      }
    }
  }

  .batch-sub {
    display: block;
    font-size: 0.82rem;
    color: ${(props) => props.theme.$gray600};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 640px;
  }

  .batch-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;

    .all-done {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 0.85rem;
      color: ${(props) => props.theme.$dark_green};

      i {
        font-size: 16px;
      }
    }
  }

  .batch-progress {
    height: 3px;
    background: ${(props) => props.theme.$gray200};

    div {
      height: 100%;
      background: ${(props) => props.theme.$primary_green};
      transition: width 0.3s;
    }
  }

  .batch-running {
    display: flex;
    align-items: center;
    gap: 8px 12px;
    flex-wrap: wrap;
    padding: 10px 18px;
    background: ${(props) => props.theme.$bg_green};
    font-size: 0.84rem;
    color: ${(props) => props.theme.$dark_green};

    .running-text {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .running-hint {
      color: ${(props) => props.theme.$gray600};
    }
  }

  .batch-alert {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin: 12px 18px 0;
    font-size: 0.85rem;
  }

  .batch-totals {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px 16px;
    flex-wrap: wrap;
    padding: 12px 18px;
    border-bottom: 1px solid ${(props) => props.theme.$gray200};

    p {
      margin: 0;
      font-size: 0.88rem;
      color: ${(props) => props.theme.$gray700};

      strong {
        font-size: 1rem;
        color: ${(props) => props.theme.$gray900};
      }

      span {
        color: ${(props) => props.theme.$gray500};
      }
    }

    .totals-actions {
      display: flex;
      gap: 6px;
      flex-wrap: wrap;
    }
  }

  .batch-table {
    max-height: 440px;
    overflow: auto;

    thead th {
      position: sticky;
      top: 0;
      z-index: 1;
      background: #fff;
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: ${(props) => props.theme.$gray500};
      border-top: 0;
      white-space: nowrap;
    }

    td {
      vertical-align: middle;
      font-size: 0.86rem;
      color: ${(props) => props.theme.$gray800};
    }

    tr.active td {
      background: ${(props) => props.theme.$bg_green};
    }

    .num {
      text-align: right;
      white-space: nowrap;
      font-variant-numeric: tabular-nums;

      small {
        display: block;
        color: ${(props) => props.theme.$gray500};
      }
    }

    .row-badge {
      min-width: 26px;
      height: 24px;
      padding: 0 4px;
      border-radius: 6px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 0.74rem;
      font-weight: 700;
      background: ${(props) => props.theme.$gray100};
      color: ${(props) => props.theme.$gray600};

      &.done {
        background: ${(props) => props.theme.$bg_green};
        color: ${(props) => props.theme.$dark_green};
      }

      &.running {
        background: ${(props) => props.theme.$primary_light};
        color: ${(props) => props.theme.$primary};
      }

      i {
        font-size: 15px;
      }
    }

    .item-cell {
      min-width: 260px;
    }

    .item-desc {
      margin: 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .item-meta {
      margin: 2px 0 0;
      font-size: 0.76rem;
      color: ${(props) => props.theme.$gray500};
    }

    .link-saved {
      display: inline-flex;
      align-items: center;
      gap: 3px;
      margin-top: 3px;
      border: 0;
      background: transparent;
      padding: 0;
      font-size: 0.78rem;
      font-weight: 500;
      color: ${(props) => props.theme.$dark_green};

      i {
        font-size: 14px;
      }

      &:hover {
        text-decoration: underline;
      }
    }

    .row-note {
      margin: 3px 0 0;
      font-size: 0.78rem;

      &.info {
        color: ${(props) => props.theme.$primary};
      }

      &.warn {
        color: ${(props) => props.theme.$gold};
      }

      &.danger {
        color: ${(props) => props.theme.$danger};
      }
    }

    .actions {
      white-space: nowrap;
      text-align: right;

      .btn {
        margin-right: 2px;
      }
    }

    .icon-btn {
      border: 0;
      background: transparent;
      padding: 4px;
      color: ${(props) => props.theme.$gray500};
      vertical-align: middle;

      &:hover:not(:disabled) {
        color: ${(props) => props.theme.$gray900};
      }

      &:disabled {
        opacity: 0.4;
      }

      i {
        font-size: 18px;
      }
    }
  }
`;
